export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9636.188ebcd8.jpg";